import { default as aboutUH5ffSp2mWMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsCcW6teMNxnMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93MXQaG128nKMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sample5CQ4hCj02IMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsIOGwXecM1EMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93ewe5woC4gdMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewqjHuh8vZqLMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexICG6fzszUCMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_933dJ5fcaIC9Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexz0PqYy7MTuMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93fsFtacFVtZMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexNBKZr4JzXhMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsMnK7d5DZpOMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings2EaYULL6srMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsvzgOwwxXGnMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93BynKUZ2nMJMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexc1ypn4b2aDMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirma8iAZyTs3xMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmp83NKfm2sfMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendar1MHWjMLw4wMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatqOoaQ7PCDzMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/chat.vue?macro=true";
import { default as about6sf2ri7jubMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedKRGtDgNIVXMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersgkAMnXVEm1Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93XvtZL65KQJMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editaTr8Aoc7iCMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93TBKGpTkTH5Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityg6nnY5gLCHMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93PdKTzshlkwMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_933FrBgMi9wzMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardRDtKXZf8b9Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexfCgcO0kYJcMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutqvYnJ2wj1fMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productA0Gcy2EchkMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsW8us5fUd85Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93JIGmEH7GCKMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexuuPatEpYoxMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93vlMhjoqseeMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93QgGbTaA9iMMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as index1ccpPSiZQ6Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_9332FYIAFYZPMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinGQY3KetNFCMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/join.vue?macro=true";
import { default as loginJ64SiM5PyQMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/login.vue?macro=true";
import { default as logoutiMvP0bw4imMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93x0CfEBdzWOMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93keZTPF6zd7Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93KAk1l0PBiOMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favorites9dDw7NBQqMMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studioscmHVDpkuJhMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinyzjP2xxZkjMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93KhJIOlvlxHMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as index2axiljTpEYMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexGDL2h080q2Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutQnv5meHJiGMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentL5wdyG31A9Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventseYf1rB9cvGMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_938ClRh3aMA1Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleJUCIQmCU0jMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsvvRvDKiMgQMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93rmBthdhcdIMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewxxOORe9UolMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexT0xdg4yZdAMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93HfI6AkQGUiMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexdCwCN2pttzMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93GAwyq8tVrdMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexPOpRAfzYvzMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsT9GIlhZ0lbMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsUfy5IfJiKgMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsTfYqeIW9NQMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93fLnDprmEHtMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexMoijcWwo1BMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexBvDXRMo2Y5Meta } from "/tmp/build_2c5fd183/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchases0P9TKgIWKRMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsdbRMUQTjdWMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93n45FIhiBMhMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93GMjQ5nDXxWMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetpsaIPQkRcOMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/reset.vue?macro=true";
import { default as shopBsCf3yS5GNMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/shop.vue?macro=true";
import { default as signupzXBEWkkpSEMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/signup.vue?macro=true";
import { default as liveMPoSio8mSiMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsxK5uFGzlzeMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93xTPhPhEyveMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactV0EsyF0xTBMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullRLYRSZgvIpMeta } from "/tmp/build_2c5fd183/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93BynKUZ2nMJMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93BynKUZ2nMJMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93BynKUZ2nMJMeta || {},
    alias: _91product_id_93BynKUZ2nMJMeta?.alias || [],
    redirect: _91product_id_93BynKUZ2nMJMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutUH5ffSp2mWMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutUH5ffSp2mWMeta?.path ?? "about",
    meta: aboutUH5ffSp2mWMeta || {},
    alias: aboutUH5ffSp2mWMeta?.alias || [],
    redirect: aboutUH5ffSp2mWMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsCcW6teMNxnMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsCcW6teMNxnMeta?.path ?? "events",
    meta: eventsCcW6teMNxnMeta || {},
    alias: eventsCcW6teMNxnMeta?.alias || [],
    redirect: eventsCcW6teMNxnMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93MXQaG128nKMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93MXQaG128nKMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93MXQaG128nKMeta || {},
    alias: _91media_id_93MXQaG128nKMeta?.alias || [],
    redirect: _91media_id_93MXQaG128nKMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sample5CQ4hCj02IMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sample5CQ4hCj02IMeta?.path ?? "free-sample",
    meta: free_45sample5CQ4hCj02IMeta || {},
    alias: free_45sample5CQ4hCj02IMeta?.alias || [],
    redirect: free_45sample5CQ4hCj02IMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsIOGwXecM1EMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsIOGwXecM1EMeta?.path ?? "included-products",
    meta: included_45productsIOGwXecM1EMeta || {},
    alias: included_45productsIOGwXecM1EMeta?.alias || [],
    redirect: included_45productsIOGwXecM1EMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ewe5woC4gdMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93ewe5woC4gdMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93ewe5woC4gdMeta || {},
    alias: _91media_id_93ewe5woC4gdMeta?.alias || [],
    redirect: _91media_id_93ewe5woC4gdMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewqjHuh8vZqLMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewqjHuh8vZqLMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewqjHuh8vZqLMeta || {},
    alias: viewqjHuh8vZqLMeta?.alias || [],
    redirect: viewqjHuh8vZqLMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexICG6fzszUCMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexICG6fzszUCMeta?.path ?? "lessons",
    meta: indexICG6fzszUCMeta || {},
    alias: indexICG6fzszUCMeta?.alias || [],
    redirect: indexICG6fzszUCMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_933dJ5fcaIC9Meta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_933dJ5fcaIC9Meta?.path ?? "media/:media_id()",
    meta: _91media_id_933dJ5fcaIC9Meta || {},
    alias: _91media_id_933dJ5fcaIC9Meta?.alias || [],
    redirect: _91media_id_933dJ5fcaIC9Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexz0PqYy7MTuMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexz0PqYy7MTuMeta?.path ?? "playlists/:playlist_id()",
    meta: indexz0PqYy7MTuMeta || {},
    alias: indexz0PqYy7MTuMeta?.alias || [],
    redirect: indexz0PqYy7MTuMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93fsFtacFVtZMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93fsFtacFVtZMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93fsFtacFVtZMeta || {},
    alias: _91media_id_93fsFtacFVtZMeta?.alias || [],
    redirect: _91media_id_93fsFtacFVtZMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexNBKZr4JzXhMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexNBKZr4JzXhMeta?.path ?? "playlists",
    meta: indexNBKZr4JzXhMeta || {},
    alias: indexNBKZr4JzXhMeta?.alias || [],
    redirect: indexNBKZr4JzXhMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsMnK7d5DZpOMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsMnK7d5DZpOMeta?.path ?? "private-sessions",
    meta: private_45sessionsMnK7d5DZpOMeta || {},
    alias: private_45sessionsMnK7d5DZpOMeta?.alias || [],
    redirect: private_45sessionsMnK7d5DZpOMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings2EaYULL6srMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordings2EaYULL6srMeta?.path ?? "recordings",
    meta: recordings2EaYULL6srMeta || {},
    alias: recordings2EaYULL6srMeta?.alias || [],
    redirect: recordings2EaYULL6srMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsvzgOwwxXGnMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsvzgOwwxXGnMeta?.path ?? "reviews",
    meta: reviewsvzgOwwxXGnMeta || {},
    alias: reviewsvzgOwwxXGnMeta?.alias || [],
    redirect: reviewsvzgOwwxXGnMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexc1ypn4b2aDMeta?.name ?? "buy-product-product_id",
    path: indexc1ypn4b2aDMeta?.path ?? "/buy/product/:product_id()",
    meta: indexc1ypn4b2aDMeta || {},
    alias: indexc1ypn4b2aDMeta?.alias || [],
    redirect: indexc1ypn4b2aDMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirma8iAZyTs3xMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirma8iAZyTs3xMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirma8iAZyTs3xMeta || {},
    alias: confirma8iAZyTs3xMeta?.alias || [],
    redirect: confirma8iAZyTs3xMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmp83NKfm2sfMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmp83NKfm2sfMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmp83NKfm2sfMeta || {},
    alias: confirmp83NKfm2sfMeta?.alias || [],
    redirect: confirmp83NKfm2sfMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendar1MHWjMLw4wMeta?.name ?? "calendar",
    path: calendar1MHWjMLw4wMeta?.path ?? "/calendar",
    meta: calendar1MHWjMLw4wMeta || {},
    alias: calendar1MHWjMLw4wMeta?.alias || [],
    redirect: calendar1MHWjMLw4wMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatqOoaQ7PCDzMeta?.name ?? "chat",
    path: chatqOoaQ7PCDzMeta?.path ?? "/chat",
    meta: chatqOoaQ7PCDzMeta || {},
    alias: chatqOoaQ7PCDzMeta?.alias || [],
    redirect: chatqOoaQ7PCDzMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93XvtZL65KQJMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93XvtZL65KQJMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93XvtZL65KQJMeta || {},
    alias: _91group_id_93XvtZL65KQJMeta?.alias || [],
    redirect: _91group_id_93XvtZL65KQJMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: about6sf2ri7jubMeta?.name ?? "community-groups-group_id-about",
    path: about6sf2ri7jubMeta?.path ?? "about",
    meta: about6sf2ri7jubMeta || {},
    alias: about6sf2ri7jubMeta?.alias || [],
    redirect: about6sf2ri7jubMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedKRGtDgNIVXMeta?.name ?? "community-groups-group_id-feed",
    path: feedKRGtDgNIVXMeta?.path ?? "feed",
    meta: feedKRGtDgNIVXMeta || {},
    alias: feedKRGtDgNIVXMeta?.alias || [],
    redirect: feedKRGtDgNIVXMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersgkAMnXVEm1Meta?.name ?? "community-groups-group_id-members",
    path: membersgkAMnXVEm1Meta?.path ?? "members",
    meta: membersgkAMnXVEm1Meta || {},
    alias: membersgkAMnXVEm1Meta?.alias || [],
    redirect: membersgkAMnXVEm1Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editaTr8Aoc7iCMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editaTr8Aoc7iCMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editaTr8Aoc7iCMeta || {},
    alias: community_45profile_45editaTr8Aoc7iCMeta?.alias || [],
    redirect: community_45profile_45editaTr8Aoc7iCMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93TBKGpTkTH5Meta?.name ?? "community-profile-id",
    path: _91id_93TBKGpTkTH5Meta?.path ?? "/community-profile/:id()",
    meta: _91id_93TBKGpTkTH5Meta || {},
    alias: _91id_93TBKGpTkTH5Meta?.alias || [],
    redirect: _91id_93TBKGpTkTH5Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityg6nnY5gLCHMeta?.name ?? "community",
    path: communityg6nnY5gLCHMeta?.path ?? "/community",
    meta: communityg6nnY5gLCHMeta || {},
    alias: communityg6nnY5gLCHMeta?.alias || [],
    redirect: communityg6nnY5gLCHMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93PdKTzshlkwMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93PdKTzshlkwMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93PdKTzshlkwMeta || {},
    alias: _91uuid_93PdKTzshlkwMeta?.alias || [],
    redirect: _91uuid_93PdKTzshlkwMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_933FrBgMi9wzMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_933FrBgMi9wzMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_933FrBgMi9wzMeta || {},
    alias: _91unique_id_933FrBgMi9wzMeta?.alias || [],
    redirect: _91unique_id_933FrBgMi9wzMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardRDtKXZf8b9Meta?.name ?? "dashboard",
    path: dashboardRDtKXZf8b9Meta?.path ?? "/dashboard",
    meta: dashboardRDtKXZf8b9Meta || {},
    alias: dashboardRDtKXZf8b9Meta?.alias || [],
    redirect: dashboardRDtKXZf8b9Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexfCgcO0kYJcMeta?.name ?? "event-details-event_id",
    path: indexfCgcO0kYJcMeta?.path ?? "/event/details/:event_id()",
    meta: indexfCgcO0kYJcMeta || {},
    alias: indexfCgcO0kYJcMeta?.alias || [],
    redirect: indexfCgcO0kYJcMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutqvYnJ2wj1fMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutqvYnJ2wj1fMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutqvYnJ2wj1fMeta || {},
    alias: checkoutqvYnJ2wj1fMeta?.alias || [],
    redirect: checkoutqvYnJ2wj1fMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productA0Gcy2EchkMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productA0Gcy2EchkMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productA0Gcy2EchkMeta || {},
    alias: select_45productA0Gcy2EchkMeta?.alias || [],
    redirect: select_45productA0Gcy2EchkMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsW8us5fUd85Meta?.name ?? "events",
    path: eventsW8us5fUd85Meta?.path ?? "/events",
    meta: eventsW8us5fUd85Meta || {},
    alias: eventsW8us5fUd85Meta?.alias || [],
    redirect: eventsW8us5fUd85Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93JIGmEH7GCKMeta?.name ?? "gifts-uuid",
    path: _91uuid_93JIGmEH7GCKMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93JIGmEH7GCKMeta || {},
    alias: _91uuid_93JIGmEH7GCKMeta?.alias || [],
    redirect: _91uuid_93JIGmEH7GCKMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexuuPatEpYoxMeta?.name ?? "gifts",
    path: indexuuPatEpYoxMeta?.path ?? "/gifts",
    meta: indexuuPatEpYoxMeta || {},
    alias: indexuuPatEpYoxMeta?.alias || [],
    redirect: indexuuPatEpYoxMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93vlMhjoqseeMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93vlMhjoqseeMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93vlMhjoqseeMeta || {},
    alias: _91invitation_id_93vlMhjoqseeMeta?.alias || [],
    redirect: _91invitation_id_93vlMhjoqseeMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93QgGbTaA9iMMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93QgGbTaA9iMMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93QgGbTaA9iMMeta || {},
    alias: _91product_id_93QgGbTaA9iMMeta?.alias || [],
    redirect: _91product_id_93QgGbTaA9iMMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: index1ccpPSiZQ6Meta?.name ?? "index",
    path: index1ccpPSiZQ6Meta?.path ?? "/",
    meta: index1ccpPSiZQ6Meta || {},
    alias: index1ccpPSiZQ6Meta?.alias || [],
    redirect: index1ccpPSiZQ6Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_9332FYIAFYZPMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_9332FYIAFYZPMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_9332FYIAFYZPMeta || {},
    alias: _91invitation_unique_id_9332FYIAFYZPMeta?.alias || [],
    redirect: _91invitation_unique_id_9332FYIAFYZPMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinGQY3KetNFCMeta?.name ?? "join",
    path: joinGQY3KetNFCMeta?.path ?? "/join",
    meta: joinGQY3KetNFCMeta || {},
    alias: joinGQY3KetNFCMeta?.alias || [],
    redirect: joinGQY3KetNFCMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginJ64SiM5PyQMeta?.name ?? "login",
    path: loginJ64SiM5PyQMeta?.path ?? "/login",
    meta: loginJ64SiM5PyQMeta || {},
    alias: loginJ64SiM5PyQMeta?.alias || [],
    redirect: loginJ64SiM5PyQMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutiMvP0bw4imMeta?.name ?? "logout",
    path: logoutiMvP0bw4imMeta?.path ?? "/logout",
    meta: logoutiMvP0bw4imMeta || {},
    alias: logoutiMvP0bw4imMeta?.alias || [],
    redirect: logoutiMvP0bw4imMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93x0CfEBdzWOMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93x0CfEBdzWOMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93x0CfEBdzWOMeta || {},
    alias: _91meeting_type_slug_93x0CfEBdzWOMeta?.alias || [],
    redirect: _91meeting_type_slug_93x0CfEBdzWOMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93keZTPF6zd7Meta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93keZTPF6zd7Meta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93keZTPF6zd7Meta || {},
    alias: _91meeting_unique_id_93keZTPF6zd7Meta?.alias || [],
    redirect: _91meeting_unique_id_93keZTPF6zd7Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93KAk1l0PBiOMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93KAk1l0PBiOMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93KAk1l0PBiOMeta || {},
    alias: _91meeting_unique_id_93KAk1l0PBiOMeta?.alias || [],
    redirect: _91meeting_unique_id_93KAk1l0PBiOMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites9dDw7NBQqMMeta?.name ?? "my-favorites",
    path: my_45favorites9dDw7NBQqMMeta?.path ?? "/my-favorites",
    meta: my_45favorites9dDw7NBQqMMeta || {},
    alias: my_45favorites9dDw7NBQqMMeta?.alias || [],
    redirect: my_45favorites9dDw7NBQqMMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studioscmHVDpkuJhMeta?.name ?? "my-studios",
    path: my_45studioscmHVDpkuJhMeta?.path ?? "/my-studios",
    meta: my_45studioscmHVDpkuJhMeta || {},
    alias: my_45studioscmHVDpkuJhMeta?.alias || [],
    redirect: my_45studioscmHVDpkuJhMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinyzjP2xxZkjMeta?.name ?? "optin",
    path: optinyzjP2xxZkjMeta?.path ?? "/optin",
    meta: optinyzjP2xxZkjMeta || {},
    alias: optinyzjP2xxZkjMeta?.alias || [],
    redirect: optinyzjP2xxZkjMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93KhJIOlvlxHMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93KhJIOlvlxHMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93KhJIOlvlxHMeta || {},
    alias: _91episode_id_93KhJIOlvlxHMeta?.alias || [],
    redirect: _91episode_id_93KhJIOlvlxHMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: index2axiljTpEYMeta?.name ?? "podcasts-podcast_id",
    path: index2axiljTpEYMeta?.path ?? "/podcasts/:podcast_id()",
    meta: index2axiljTpEYMeta || {},
    alias: index2axiljTpEYMeta?.alias || [],
    redirect: index2axiljTpEYMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexGDL2h080q2Meta?.name ?? "podcasts",
    path: indexGDL2h080q2Meta?.path ?? "/podcasts",
    meta: indexGDL2h080q2Meta || {},
    alias: indexGDL2h080q2Meta?.alias || [],
    redirect: indexGDL2h080q2Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93fLnDprmEHtMeta?.name ?? "product-product_id",
    path: _91product_id_93fLnDprmEHtMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93fLnDprmEHtMeta || {},
    alias: _91product_id_93fLnDprmEHtMeta?.alias || [],
    redirect: _91product_id_93fLnDprmEHtMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutQnv5meHJiGMeta?.name ?? "product-product_id-about",
    path: aboutQnv5meHJiGMeta?.path ?? "about",
    meta: aboutQnv5meHJiGMeta || {},
    alias: aboutQnv5meHJiGMeta?.alias || [],
    redirect: aboutQnv5meHJiGMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentL5wdyG31A9Meta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentL5wdyG31A9Meta?.path ?? "digital-download-content",
    meta: digital_45download_45contentL5wdyG31A9Meta || {},
    alias: digital_45download_45contentL5wdyG31A9Meta?.alias || [],
    redirect: digital_45download_45contentL5wdyG31A9Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventseYf1rB9cvGMeta?.name ?? "product-product_id-events",
    path: eventseYf1rB9cvGMeta?.path ?? "events",
    meta: eventseYf1rB9cvGMeta || {},
    alias: eventseYf1rB9cvGMeta?.alias || [],
    redirect: eventseYf1rB9cvGMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938ClRh3aMA1Meta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_938ClRh3aMA1Meta?.path ?? "free-media/:media_id()",
    meta: _91media_id_938ClRh3aMA1Meta || {},
    alias: _91media_id_938ClRh3aMA1Meta?.alias || [],
    redirect: _91media_id_938ClRh3aMA1Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleJUCIQmCU0jMeta?.name ?? "product-product_id-free-sample",
    path: free_45sampleJUCIQmCU0jMeta?.path ?? "free-sample",
    meta: free_45sampleJUCIQmCU0jMeta || {},
    alias: free_45sampleJUCIQmCU0jMeta?.alias || [],
    redirect: free_45sampleJUCIQmCU0jMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsvvRvDKiMgQMeta?.name ?? "product-product_id-included-products",
    path: included_45productsvvRvDKiMgQMeta?.path ?? "included-products",
    meta: included_45productsvvRvDKiMgQMeta || {},
    alias: included_45productsvvRvDKiMgQMeta?.alias || [],
    redirect: included_45productsvvRvDKiMgQMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93rmBthdhcdIMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93rmBthdhcdIMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93rmBthdhcdIMeta || {},
    alias: _91media_id_93rmBthdhcdIMeta?.alias || [],
    redirect: _91media_id_93rmBthdhcdIMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewxxOORe9UolMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewxxOORe9UolMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewxxOORe9UolMeta || {},
    alias: viewxxOORe9UolMeta?.alias || [],
    redirect: viewxxOORe9UolMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexT0xdg4yZdAMeta?.name ?? "product-product_id-lessons",
    path: indexT0xdg4yZdAMeta?.path ?? "lessons",
    meta: indexT0xdg4yZdAMeta || {},
    alias: indexT0xdg4yZdAMeta?.alias || [],
    redirect: indexT0xdg4yZdAMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93HfI6AkQGUiMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93HfI6AkQGUiMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93HfI6AkQGUiMeta || {},
    alias: _91media_id_93HfI6AkQGUiMeta?.alias || [],
    redirect: _91media_id_93HfI6AkQGUiMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexdCwCN2pttzMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexdCwCN2pttzMeta?.path ?? "playlists/:playlist_id()",
    meta: indexdCwCN2pttzMeta || {},
    alias: indexdCwCN2pttzMeta?.alias || [],
    redirect: indexdCwCN2pttzMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93GAwyq8tVrdMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93GAwyq8tVrdMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93GAwyq8tVrdMeta || {},
    alias: _91media_id_93GAwyq8tVrdMeta?.alias || [],
    redirect: _91media_id_93GAwyq8tVrdMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexPOpRAfzYvzMeta?.name ?? "product-product_id-playlists",
    path: indexPOpRAfzYvzMeta?.path ?? "playlists",
    meta: indexPOpRAfzYvzMeta || {},
    alias: indexPOpRAfzYvzMeta?.alias || [],
    redirect: indexPOpRAfzYvzMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsT9GIlhZ0lbMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsT9GIlhZ0lbMeta?.path ?? "private-sessions",
    meta: private_45sessionsT9GIlhZ0lbMeta || {},
    alias: private_45sessionsT9GIlhZ0lbMeta?.alias || [],
    redirect: private_45sessionsT9GIlhZ0lbMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsUfy5IfJiKgMeta?.name ?? "product-product_id-recordings",
    path: recordingsUfy5IfJiKgMeta?.path ?? "recordings",
    meta: recordingsUfy5IfJiKgMeta || {},
    alias: recordingsUfy5IfJiKgMeta?.alias || [],
    redirect: recordingsUfy5IfJiKgMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsTfYqeIW9NQMeta?.name ?? "product-product_id-reviews",
    path: reviewsTfYqeIW9NQMeta?.path ?? "reviews",
    meta: reviewsTfYqeIW9NQMeta || {},
    alias: reviewsTfYqeIW9NQMeta?.alias || [],
    redirect: reviewsTfYqeIW9NQMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexMoijcWwo1BMeta?.name ?? "product",
    path: indexMoijcWwo1BMeta?.path ?? "/product",
    meta: indexMoijcWwo1BMeta || {},
    alias: indexMoijcWwo1BMeta?.alias || [],
    redirect: indexMoijcWwo1BMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexBvDXRMo2Y5Meta?.name ?? "profile",
    path: indexBvDXRMo2Y5Meta?.path ?? "/profile",
    meta: indexBvDXRMo2Y5Meta || {},
    alias: indexBvDXRMo2Y5Meta?.alias || [],
    redirect: indexBvDXRMo2Y5Meta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchases0P9TKgIWKRMeta?.name ?? "profile-purchases",
    path: purchases0P9TKgIWKRMeta?.path ?? "/profile/purchases",
    meta: purchases0P9TKgIWKRMeta || {},
    alias: purchases0P9TKgIWKRMeta?.alias || [],
    redirect: purchases0P9TKgIWKRMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsdbRMUQTjdWMeta?.name ?? "profile-redemptions",
    path: redemptionsdbRMUQTjdWMeta?.path ?? "/profile/redemptions",
    meta: redemptionsdbRMUQTjdWMeta || {},
    alias: redemptionsdbRMUQTjdWMeta?.alias || [],
    redirect: redemptionsdbRMUQTjdWMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93n45FIhiBMhMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93n45FIhiBMhMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93n45FIhiBMhMeta || {},
    alias: _91quiz_id_93n45FIhiBMhMeta?.alias || [],
    redirect: _91quiz_id_93n45FIhiBMhMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93GMjQ5nDXxWMeta?.name ?? "reset-password-uid-token",
    path: _91token_93GMjQ5nDXxWMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93GMjQ5nDXxWMeta || {},
    alias: _91token_93GMjQ5nDXxWMeta?.alias || [],
    redirect: _91token_93GMjQ5nDXxWMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetpsaIPQkRcOMeta?.name ?? "reset",
    path: resetpsaIPQkRcOMeta?.path ?? "/reset",
    meta: resetpsaIPQkRcOMeta || {},
    alias: resetpsaIPQkRcOMeta?.alias || [],
    redirect: resetpsaIPQkRcOMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopBsCf3yS5GNMeta?.name ?? "shop",
    path: shopBsCf3yS5GNMeta?.path ?? "/shop",
    meta: shopBsCf3yS5GNMeta || {},
    alias: shopBsCf3yS5GNMeta?.alias || [],
    redirect: shopBsCf3yS5GNMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupzXBEWkkpSEMeta?.name ?? "signup",
    path: signupzXBEWkkpSEMeta?.path ?? "/signup",
    meta: signupzXBEWkkpSEMeta || {},
    alias: signupzXBEWkkpSEMeta?.alias || [],
    redirect: signupzXBEWkkpSEMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveMPoSio8mSiMeta?.name ?? "streaming-event_id-live",
    path: liveMPoSio8mSiMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveMPoSio8mSiMeta || {},
    alias: liveMPoSio8mSiMeta?.alias || [],
    redirect: liveMPoSio8mSiMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsxK5uFGzlzeMeta?.name ?? "tips",
    path: tipsxK5uFGzlzeMeta?.path ?? "/tips",
    meta: tipsxK5uFGzlzeMeta || {},
    alias: tipsxK5uFGzlzeMeta?.alias || [],
    redirect: tipsxK5uFGzlzeMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93xTPhPhEyveMeta?.name ?? "waiver-uuid",
    path: _91uuid_93xTPhPhEyveMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93xTPhPhEyveMeta || {},
    alias: _91uuid_93xTPhPhEyveMeta?.alias || [],
    redirect: _91uuid_93xTPhPhEyveMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactV0EsyF0xTBMeta?.name ?? "widgets-calendars-compact",
    path: compactV0EsyF0xTBMeta?.path ?? "/widgets/calendars/compact",
    meta: compactV0EsyF0xTBMeta || {},
    alias: compactV0EsyF0xTBMeta?.alias || [],
    redirect: compactV0EsyF0xTBMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullRLYRSZgvIpMeta?.name ?? "widgets-calendars-full",
    path: fullRLYRSZgvIpMeta?.path ?? "/widgets/calendars/full",
    meta: fullRLYRSZgvIpMeta || {},
    alias: fullRLYRSZgvIpMeta?.alias || [],
    redirect: fullRLYRSZgvIpMeta?.redirect,
    component: () => import("/tmp/build_2c5fd183/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]